<!--
 * @Author: 王枫叶
 * @Date: 2020-10-21 16:53:48
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-10-31 01:55:11
-->
<template>
  <!-- <div class="louFeng-box"  v-if="hasItemAuth('adCfg')"> -->
      <div class="louFeng-box">
    <!--操作栏-->
    <div class="action-bar">
        广告出现的频次: <el-input style="width:160px" v-model.number="this.adInterval" size="small" disabled></el-input>
        <el-button style="margin-right:20px" type="success" size="small" icon="el-icon-edit" @click="editor(adInterval)">编辑</el-button>
        <el-button  type="primary" size="small" @click="Action('add')" class="add-input">+新增楼凤广告配置</el-button>        
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="img" label="图片" align="center" min-width="190">
        <template slot-scope="scope">
          <img-load :src="imgUrl + scope.row.img" :width="'140px'" :height="'100px'" />
        </template>
      </el-table-column>
      <el-table-column prop="url" label="跳转链接" align="center" min-width="180" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.url}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否激活" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.isActive==true?'激活':'未激活' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="Action('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑弹框-->
    <edit-page ref="editPage" @handlerChannelList="getLfAdList"></edit-page>
    <!-- 编辑广告出现频次 -->
    <dr-cfg ref="drCfg" @handlerChannelList1="getLoufCfgList"></dr-cfg>  
  </div>
</template>

<script>
import API from '@/api'
import editPage from './components/editPage'
import drCfg from './components/drCfg'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      adInterval: '',
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      imgUrl: baseConfig.imgUrl,    
    }
  },
  components: {
    editPage,
    drCfg
  },
  created() {
    this.getLfAdList()
    this.getLoufCfgList()
  },
  methods: {
    // 请求广告配置列表
    getLfAdList(type) {
      this.loading = true
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      API.getLfAdList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list
          } else {
            this.tableData = []
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    //获取广告出现的频次
    getLoufCfgList() {
      API.getLoufCfgList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.adInterval = res.data.adInterval
          } else {
            this.adInterval = ''
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 新增、编辑操作
    Action(type, data) {
      this.$refs.editPage.open(type, data)
    },
    editor(adInterval){
       this.$refs.drCfg.open(adInterval)
    },            
    //删除
    remove(row) {
      this.$confirm('您确定要删除这条广告吗？', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteLfAd({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
            this.getLfAdList()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    },   
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getLfAdList()
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getLfAdList()
    },
  },
}
</script>

<style lang="scss" scoped>
.action-bar{
  display: flex;

}
.lf_cfg {
  .lf_cfg_content {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    div {
      margin-bottom: 10px;
      span {
        color: cadetblue;
      }
      .el-button {
        background: rgba(230, 55, 101, 0.8);
        margin-left: 20px;
        span {
          color: #ffffff;
        }
      }
    }
    .btn_style {
      padding: 4px 8px;
      color: #000000;
      background: #327720;
      border: 1px solid #999999;
      border-radius: 20px;
    }
  }
}
</style>
